import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const fetchCourses = createAsyncThunk(
    'courses/fetch',
    async ({uuid, skillName, skillLevel, userKnows, userMissed, why }) => {
        const maxRetries = 2;
        let retries = 0;
        while (retries < maxRetries) {
            try {
                const response = await axios.post('https://ninjacurate.learntube.ai/course_generate', {
                    uid:uuid, skill_name: skillName, skill_difficulty: skillLevel, user_knows: userKnows, user_missed: userMissed, why
                });
                if (response.data === true || response.data === false) {
                    const navigate = useNavigate()
                    navigate('/')
                    return;
                }
                return response.data;
            } catch (err) {
                console.log(err);
                retries += 1;
            }
        }
    }
)

const initialState = {
    courses: {}
}

const coursesSlice = createSlice({
    name: 'courses',
    initialState,
    reducers: {
        setCourseData: (state, action) => {
            state.courses = action.payload
        },
        resetCourseData: (state) => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCourses.fulfilled, (state, action) => {
            state.courses =  action.payload;
        });
    },
});

export const { resetCourseData, setCourseData } = coursesSlice.actions
export const selectCourses = (state) => state.courses.courses;
export default coursesSlice.reducer;